import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('ControlGroup');

export const controlGroupClassNames = {
  root: factory.root(),
  header: factory.element('header'),
  label: factory.element('label'),
  description: factory.element('description'),
  controls: factory.element('controls'),
  errorMessage: factory.element('error-message'),
  disabled: factory.attribute('disabled'),
  error: factory.attribute('error'),
};
